import {EventEmitter, Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class PreviousUrlService {
  previousUrl: string;
  currentUrl: string;
  urlStack = [];
  private previousURLs = new BehaviorSubject<number>(0);
  private maxLength = 2;
  previousNumber$ = this.previousURLs.asObservable();
  constructor(private router: Router) {
  }
  init() {
      this.router.events
          .filter(event => event instanceof NavigationEnd)
          .subscribe(e => {
              this.previousUrl = this.currentUrl;
              this.currentUrl = (e as NavigationEnd).url;
              if  (this.currentUrl !== this.urlStack[this.urlStack.length - 1] &&
                  this.currentUrl !== this.urlStack[this.urlStack.length - 2]) {
                  this.urlStack.push(this.currentUrl);
                  if (this.urlStack.length === this.maxLength) {
                      this.urlStack.shift();
                  }
              }
              if (this.currentUrl === this.urlStack[this.urlStack.length - 2])
                this.urlStack.pop();
              this.previousURLs.next(this.urlStack.length);
          });
  }
  public getPrevUrl() {
    return this.previousUrl;
  }

  public goBack() {
    this.urlStack.pop();
    return this.urlStack[this.urlStack.length - 1];
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-renderer/services/previous-url/previous-url.service.ts